/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCards, Mousewheel } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { Button, Image } from 'react-bootstrap'
import { mobilePhone, wavenet_logo, dragging } from '../asset'
import CIIcon from './CIIcon'

function MagicCardPreview({ srcs, redirectImage, redirectUrl }) {
  const [showIntro, setShowIntro] = useState(false)
  const [imageUrls, setImageUrls] = useState([])
  const [swiperReady, setSwiperReady] = useState(false)
  const [showSwiper, setShowSwiper] = useState(true)
  const [hasPlayedIntro, setHasPlayedIntro] = useState(false)
  const swiperWrapperRef = useRef(null)

  const swiperInstanceRef = useRef(null)
  const swiperRef = useRef(null)
  const containerRef = useRef(null)

  const IntroVideo = srcs.find((s) => s.label === 'Intro video')

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob)
      return URL.createObjectURL(file)
    if (typeof file === 'string') return file
    return ''
  }

  useEffect(() => {
    const Pic = srcs
      .filter((s) => s.label?.startsWith('Pic'))
      .sort((a, b) => {
        const getNum = (label) => parseInt(label.match(/\d+$/)?.[0] || '0', 10)
        return getNum(a.label) - getNum(b.label)
      })

    const urlsToRevoke = []
    const urls = Pic.map((img) => {
      if (img?.file instanceof File || img?.file instanceof Blob) {
        const url = URL.createObjectURL(img.file)
        urlsToRevoke.push(url)
        return url
      }
      if (typeof img?.file === 'string') return img.file
      return ''
    })

    setImageUrls(urls)

    return () => {
      // urlsToRevoke.forEach((url) => URL.revokeObjectURL(url))
    }
  }, [srcs])

  useEffect(() => {
    const container = containerRef.current
    const target = swiperWrapperRef.current

    if (!container || !target || showIntro || !swiperReady || hasPlayedIntro)
      return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowIntro(true)
          setHasPlayedIntro(true) // ✅ 播放過後設為 true
          observer.disconnect()

          setTimeout(() => {
            setShowIntro(false)
          }, 3000)
        }
      },
      { threshold: 1.0 }
    )

    observer.observe(target)

    return () => {
      observer.disconnect()
    }
  }, [showIntro, swiperReady, hasPlayedIntro])

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      {/* 頂部內容 */}
      <div className="w-100 pb-1">
        <img
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
          alt="Mobile Phone"
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {/* Intro Video */}
      {IntroVideo?.file && showIntro && (
        <video
          src={getPreviewURL(IntroVideo.file)}
          autoPlay
          muted
          playsInline
          style={{
            position: 'absolute',
            bottom: '10%',
            width: '240px',
            zIndex: 2000,
          }}
        />
      )}

      {/* Swiper 區塊 */}
      {!showIntro && showSwiper && imageUrls.length > 0 && (
        <div style={{ position: 'relative', width: '230px' }}>
          <Button
            onClick={() => setShowSwiper(false)}
            style={{
              position: 'absolute',
              top: '3%',
              right: '0%',
              zIndex: 2100,
              background: 'rgba(0,0,0,0.5)',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: '23px',
              height: '23px',
              fontSize: '12px',
              padding: '0',
              cursor: 'pointer',
            }}
          >
            ✕
          </Button>
          <img
            src={dragging}
            alt="Drag Hint"
            style={{
              position: 'absolute',
              bottom: '65%',
              left: '15px',
              width: '40px',
              height: 'auto',
              zIndex: 1150,
              animation: 'dragHintLeftRight 1.8s ease-in-out infinite',
              pointerEvents: 'none',
              opacity: 0.75,
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderRadius: '50%',
              cursor: 'grab',
            }}
          />
          <div
            ref={swiperWrapperRef}
            style={{ position: 'relative', width: '230px' }}
          >
            <Swiper
              ref={swiperRef}
              spaceBetween={50}
              slidesPerView={1}
              effect="cards"
              modules={[EffectCards, Mousewheel]}
              mousewheel
              className="p-3"
              style={{ width: '240px', height: 'auto' }}
              onClick={() => {
                if (redirectImage) window.open(redirectImage, '_blank')
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
              onSwiper={(swiper) => {
                setSwiperReady(true)
                swiperInstanceRef.current = swiper
              }}
              onSlideChange={(swiper) => {
                const isLast = swiper.activeIndex === imageUrls.length - 1
                if (isLast && redirectUrl) {
                  setTimeout(() => {
                    window.open(redirectUrl, '_blank')
                  }, 1000)
                }
              }}
            >
              {imageUrls.map((src, index) => (
                <SwiperSlide key={index} className="slide-card-img">
                  <img src={src} alt={`Pic ${index + 1}`} />
                </SwiperSlide>
              ))}
              <CIIcon />
            </Swiper>
          </div>
        </div>
      )}

      {/* 底部內容 */}
      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

MagicCardPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ).isRequired,
  redirectImage: PropTypes.string,
  redirectUrl: PropTypes.string,
}

MagicCardPreview.defaultProps = {
  redirectImage: '',
  redirectUrl: '',
}

export default MagicCardPreview
